module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Qy3wwW/tc-custom/9781460331668.jpg?1703823903602",
      "alt": "This image is the cover for the book Return of the Prodigal Gilvry, The Gilvrys of Dunross"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Return of the Prodigal Gilvry, The Gilvrys of Dunross\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A highlander seeking revenge must keep his promise to help a beautiful widow in this Scottish historical romance.")]), _c('br'), _c('br'), _c('i', [_vm._v("Dundee, Scotland, 1822")]), _vm._v(". Though he bears the scars of betrayal, Andrew Gilvry was once a devastatingly handsome man. Though he craves vengeance for his brother’s treachery, he has returned to Scotland to fulfill a noble promise made to a dying man. The widowed Rowena MacDonald has been entrusted to his care, and Drew must do all he can to protect her. . . ."), _c('br'), _c('br'), _vm._v("But Drew’s honor is about to be tested—because there’s something in Rowena’s dove-gray eyes that awakens a flame long extinguished. And on a perilous journey across the Highlands, with only this alluring woman for company, how long can he deny his desires?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ann Lethbridge\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0